import { useState } from 'react';
import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';
import { Link } from 'react-router-dom';

interface NewsItem {
  id: number;
  date: string;
  category: string;
  title: string;
  excerpt: string;
  image: string;
}

export default function NewsPage() {
  const [selectedCategory, setSelectedCategory] = useState('すべて');

  const categories = ['すべて', 'プレスリリース', '研究成果', 'イベント', '製品情報'];

  const newsItems: NewsItem[] = [
    {
      id: 1,
      date: '2024.03.15',
      category: 'プレスリリース',
      title: 'エクソソーム（エキソソーム）を活用した新しい化粧品原料の開発に成功',
      excerpt: 'Exosome Oneは、最新のバイオテクノロジーを駆使し、高品質なエクソソーム（エキソソーム）を配合した革新的な化粧品原料の開発に成功しました。この新原料は、肌の再生力を高め、エイジングケアに優れた効果を発揮します。',
      image: 'https://public.readdy.ai/ai/img_res/c48a202b96bb2d926f02c776d95ee1e5.jpg'
    },
    {
      id: 2,
      date: '2024.03.10',
      category: '研究成果',
      title: '再生医療分野における幹細胞培養技術の革新的進展を発表',
      excerpt: '当社の研究チームは、幹細胞培養における新しい手法を確立し、従来比で培養効率を40%向上させることに成功しました。この技術は再生医療の発展に大きく貢献することが期待されています。',
      image: 'https://readdy.ai/api/search-image?query=advanced%20stem%20cell%20cultivation%20laboratory%20with%20high-tech%20equipment%20and%20microscopes%20showing%20cellular%20research%20in%20clean%20modern%20facility%20with%20soft%20teal%20lighting%20scientific%20innovation%20atmosphere&width=800&height=500&seq=news2&orientation=landscape'
    },
    {
      id: 3,
      date: '2024.03.05',
      category: 'イベント',
      title: '第15回再生医療学会にて研究成果を発表',
      excerpt: 'Exosome Oneは、3月20日から22日まで開催される第15回再生医療学会において、エクソソーム（エキソソーム）を用いた最新の研究成果を発表いたします。多くの専門家との交流を通じて、さらなる技術革新を目指します。',
      image: 'https://readdy.ai/api/search-image?query=professional%20medical%20conference%20presentation%20hall%20with%20modern%20stage%20and%20audience%20showing%20regenerative%20medicine%20symposium%20with%20clean%20white%20and%20teal%20color%20scheme%20scientific%20event%20atmosphere&width=800&height=500&seq=news3&orientation=landscape'
    },
    {
      id: 4,
      date: '2024.02.28',
      category: '製品情報',
      title: 'OEM受託製造サービスの生産能力を拡大',
      excerpt: '需要の増加に対応するため、当社のOEM受託製造施設を拡張し、月間生産能力を2倍に増強いたしました。より多くのお客様のニーズにお応えできる体制を整えました。',
      image: 'https://readdy.ai/api/search-image?query=modern%20pharmaceutical%20manufacturing%20facility%20with%20clean%20production%20lines%20and%20quality%20control%20equipment%20showing%20expanded%20capacity%20in%20bright%20white%20environment%20with%20teal%20accents%20professional%20industrial%20atmosphere&width=800&height=500&seq=news4&orientation=landscape'
    },
    {
      id: 5,
      date: '2024.02.20',
      category: 'プレスリリース',
      title: '大手化粧品メーカーとの戦略的パートナーシップを締結',
      excerpt: 'Exosome Oneは、国内大手化粧品メーカーとエクソソーム（エキソソーム）原料の供給に関する長期契約を締結しました。この提携により、より多くの消費者に高品質な製品をお届けできるようになります。',
      image: 'https://readdy.ai/api/search-image?query=professional%20business%20partnership%20handshake%20in%20modern%20corporate%20office%20with%20cosmetic%20products%20display%20showing%20strategic%20collaboration%20in%20clean%20bright%20environment%20with%20teal%20accents&width=800&height=500&seq=news5&orientation=landscape'
    },
    {
      id: 6,
      date: '2024.02.15',
      category: '研究成果',
      title: 'エクソソーム（エキソソーム）の品質管理技術で特許を取得',
      excerpt: '当社が独自に開発したエクソソーム（エキソソーム）の品質管理および純度測定技術について、日本国内での特許を取得いたしました。この技術により、より安全で高品質な製品の提供が可能になります。',
      image: 'https://readdy.ai/api/search-image?query=scientific%20patent%20certificate%20and%20quality%20control%20testing%20equipment%20in%20modern%20laboratory%20showing%20exosome%20analysis%20technology%20with%20clean%20white%20environment%20and%20teal%20lighting%20professional%20atmosphere&width=800&height=500&seq=news6&orientation=landscape'
    },
    {
      id: 7,
      date: '2024.02.10',
      category: 'イベント',
      title: '工場見学会を開催いたします',
      excerpt: '3月15日に、当社の最新設備を備えた製造施設の見学会を開催いたします。エクソソーム（エキソソーム）の製造プロセスや品質管理体制をご覧いただけます。参加ご希望の方はお問い合わせください。',
      image: 'https://readdy.ai/api/search-image?query=modern%20biotechnology%20factory%20tour%20with%20visitors%20observing%20clean%20manufacturing%20facility%20and%20advanced%20equipment%20showing%20transparent%20production%20process%20in%20bright%20white%20environment%20with%20teal%20accents&width=800&height=500&seq=news7&orientation=landscape'
    },
    {
      id: 8,
      date: '2024.02.05',
      category: '製品情報',
      title: '新しいエクソソーム（エキソソーム）配合美容液シリーズを発売',
      excerpt: '高濃度エクソソーム（エキソソーム）を配合した新しい美容液シリーズの販売を開始いたしました。肌の深層まで浸透し、ハリと潤いを与える革新的な製品です。',
      image: 'https://readdy.ai/api/search-image?query=elegant%20cosmetic%20serum%20bottles%20with%20exosome%20formula%20on%20clean%20white%20surface%20with%20soft%20teal%20lighting%20showing%20premium%20beauty%20product%20line%20professional%20product%20photography&width=800&height=500&seq=news8&orientation=landscape'
    },
    {
      id: 9,
      date: '2024.01.25',
      category: 'プレスリリース',
      title: '研究開発センターの新設を発表',
      excerpt: 'Exosome Oneは、エクソソーム（エキソソーム）研究のさらなる発展を目指し、最新設備を備えた研究開発センターを新設することを発表いたしました。2024年秋の稼働開始を予定しています。',
      image: 'https://readdy.ai/api/search-image?query=modern%20research%20and%20development%20center%20building%20exterior%20with%20clean%20architectural%20design%20and%20glass%20facade%20showing%20biotechnology%20facility%20with%20teal%20accents%20professional%20corporate%20atmosphere&width=800&height=500&seq=news9&orientation=landscape'
    }
  ];

  const filteredNews = selectedCategory === 'すべて' 
    ? newsItems 
    : newsItems.filter(item => item.category === selectedCategory);

  return (
    <div className="min-h-screen bg-white">
      <Header />
      
      {/* Hero Section */}
      <section className="relative pt-32 pb-20 bg-gradient-to-br from-teal-50 to-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center">
            <h1 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6">
              お知らせ
            </h1>
            <p className="text-lg text-gray-600 max-w-3xl mx-auto">
              Exosome Oneの最新情報、研究成果、イベント情報などをお届けします
            </p>
          </div>
        </div>
      </section>

      {/* Category Filter */}
      <section className="py-8 border-b border-gray-200 sticky top-20 bg-white z-40">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex flex-wrap gap-3 justify-center">
            {categories.map((category) => (
              <button
                key={category}
                onClick={() => setSelectedCategory(category)}
                className={`px-6 py-2 rounded-full text-sm font-medium transition-all whitespace-nowrap cursor-pointer ${
                  selectedCategory === category
                    ? 'bg-teal-600 text-white shadow-md'
                    : 'bg-gray-100 text-gray-700 hover:bg-gray-200'
                }`}
              >
                {category}
              </button>
            ))}
          </div>
        </div>
      </section>

      {/* News List */}
      <section className="py-16">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            {filteredNews.map((news) => (
              <article 
                key={news.id}
                className="bg-white rounded-lg overflow-hidden shadow-md hover:shadow-xl transition-shadow cursor-pointer group"
              >
                <div className="relative w-full h-48 overflow-hidden">
                  <img 
                    src={news.image}
                    alt={news.title}
                    className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-300"
                  />
                  <div className="absolute top-4 left-4">
                    <span className="inline-block px-3 py-1 bg-teal-600 text-white text-xs font-medium rounded-full">
                      {news.category}
                    </span>
                  </div>
                </div>
                <div className="p-6">
                  <time className="text-sm text-gray-500 font-medium">{news.date}</time>
                  <h3 className="mt-3 text-lg font-bold text-gray-900 line-clamp-2 group-hover:text-teal-600 transition-colors">
                    {news.title}
                  </h3>
                  <p className="mt-3 text-sm text-gray-600 line-clamp-3">
                    {news.excerpt}
                  </p>
                  <div className="mt-4 flex items-center text-teal-600 text-sm font-medium group-hover:gap-2 transition-all">
                    詳しく見る
                    <i className="ri-arrow-right-line ml-1"></i>
                  </div>
                </div>
              </article>
            ))}
          </div>

          {/* Pagination */}
          <div className="mt-16 flex justify-center items-center gap-2">
            <button className="w-10 h-10 flex items-center justify-center rounded-lg border border-gray-300 text-gray-600 hover:bg-gray-50 transition-colors cursor-pointer">
              <i className="ri-arrow-left-s-line text-lg"></i>
            </button>
            <button className="w-10 h-10 flex items-center justify-center rounded-lg bg-teal-600 text-white font-medium cursor-pointer">
              1
            </button>
            <button className="w-10 h-10 flex items-center justify-center rounded-lg border border-gray-300 text-gray-600 hover:bg-gray-50 transition-colors cursor-pointer">
              2
            </button>
            <button className="w-10 h-10 flex items-center justify-center rounded-lg border border-gray-300 text-gray-600 hover:bg-gray-50 transition-colors cursor-pointer">
              3
            </button>
            <button className="w-10 h-10 flex items-center justify-center rounded-lg border border-gray-300 text-gray-600 hover:bg-gray-50 transition-colors cursor-pointer">
              <i className="ri-arrow-right-s-line text-lg"></i>
            </button>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-20 bg-gradient-to-br from-teal-600 to-teal-700">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h2 className="text-3xl md:text-4xl font-bold text-white mb-6">
            最新情報をお見逃しなく
          </h2>
          <p className="text-lg text-teal-50 mb-8">
            Exosome Oneの最新ニュースやイベント情報をメールでお届けします
          </p>
          <Link 
            to="/contact"
            className="inline-flex items-center gap-2 px-8 py-4 bg-white text-teal-600 rounded-lg font-semibold hover:bg-teal-50 transition-colors shadow-lg whitespace-nowrap cursor-pointer"
          >
            お問い合わせ
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>
      </section>

      <Footer />
    </div>
  );
}